import QueryString from 'query-string';

export const createWaysApiUrl = ({ service, params }) => {
  const query = params ? `?${QueryString.stringify(params)}` : '';
  return `${process.env.REACT_APP_URL_API}${service}${query}`;
};
